<template>
  <div>
    <b-dropdown-item-button
      action
      @click.prevent="showMembership(companyNotification.id)"
      style="cursor:pointer"
    >
      <b-row align-v="center">
        <b-col md="auto">
          <!-- Avatar -->
          <i style="font-size:25px" class="icomoon icon-membership"></i>
        </b-col>
        <b-col class="ml--2">
          <div class="d-flex justify-content-between align-items-center">
            <div>
              <h4 class="mb-0 text-sm">
                Membership #{{ companyNotification.id }}
              </h4>
            </div>
            <div class="text-right text-muted">
              <small>
                {{
                  companyNotification.dateTimeConverted | moment("MM/DD/YYYY")
                }}
                {{
                  companyNotification.dateTimeConverted | moment("hh:mm:ss A")
                }}
              </small>
            </div>
          </div>
          <p class="text-sm mb-0">
            Past Due {{ (companyNotification.amountDue / 100) | currency }}
          </p>
        </b-col>
      </b-row>
    </b-dropdown-item-button>
  </div>
</template>

<script>
export default {
  name: "CMBPastDueCompanyNotification",
  props: { companyNotification: null },
  methods: {
    showMembership(id) {
      this.$emitter.emit("show-customer-membership-billing", id);
    },
  },
};
</script>

<style></style>
